import Image from "next/image";
import Link from "next/link";

const CallToActions = () => {
  const calltoActionContent = {
    title: "Earn a 5% Referral Bonus",
    text: `Anyone using your link to purchase NAMX on the Coinstore exchange allows you to claim a 5% bonus in NAMX!`,
    btnText: "Start Earning",
  };
  return (
    <div className="container">
      <div className="relative z-10 overflow-hidden rounded-2.5xl px-16 py-24 lg:px-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 h-[150%] dark:hidden">
          <Image
            width={1920}
            height={900}
            src="/images/gradient.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <picture className="pointer-events-none absolute inset-0 -z-10 hidden h-[150%] dark:block">
          <Image
            width={1170}
            height={466}
            src="/images/gradient_dark.jpg"
            alt="gradient dark"
            className="h-full w-full object-cover"
          />
        </picture>
        <Image
          width={301}
          height={239}
          src="/images/crypto-trading/crypto_trading_cta_icons.png"
          alt="cta"
          className="pointer-events-none absolute top-1/2 right-1/4 -z-10 -translate-y-1/2"
        />
        {/* End images */}

        <div className="lg:flex lg:justify-between">
          <div className="mb-6 max-w-lg lg:mb-0">
            <h2 className="mb-5 font-display text-3xl text-jacarta-700 dark:text-white">
              {calltoActionContent.title}
            </h2>
            <p className="text-lg leading-normal dark:text-jacarta-300">
              {calltoActionContent.text}
            </p>
          </div>
          <Link
            href="/competitions"
            className="inline-block self-center rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
          >
            {calltoActionContent.btnText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CallToActions;
